import { useAuth } from './AuthProvider';

export const modules = [
  ['Dashboard', '/dashboard'], ['Warehouse', '/warehouses'], ['Customers', '/customers'],
  ['Inventory', '/inventory'], ['PackagingTypes', '/packaging-types'], ['Units', '/units'], ['ContainerPlanning', '/container-planning'], ['Users', '/users'],
];
export function canRead(user, module) {
  return user?.permissions?.includes(`${module}.Read`) === true || canWrite(user, module);
}
export function canWrite(user, module) { return user?.permissions?.includes(`${module}.Write`) === true; }
export function homePath(user) { return modules.find(([module]) => canRead(user, module))?.[1] || '/access-denied'; }
export function usePermissions() {
  const { user } = useAuth() || {};
  return { canRead: module => canRead(user, module), canWrite: module => canWrite(user, module) };
}
